import React from "react";
import {Box,TextField, MenuItem} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {
genreSelected,
} from "../../store/Store";

function GenreFilter({data,label,fid}){
    const dispatch = useDispatch();
    const genre = useSelector((state)=>state.API.genreText);

    function selectOption(e){
        dispatch(genreSelected(e.target.value));
    }

	return (
		<Box className="specific_filter">
			<TextField value={genre}
                       select
                       label = {label}
                       variant="filled"
                       style={{width:"100%"}}
                       color="success"
                       size="small"
                       onChange={selectOption}
                       >
                {
                    data.map((item,index)=>{
                        return <MenuItem value={item} key={index}>{item}</MenuItem>
                    })
                }

            </TextField>
		</Box>
	);
}

export default GenreFilter;